import React, { useState, useEffect } from "react";
import ProfileBox from "../../Components/ProfileBox/ProfileBox";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import Modal from "../../Components/Modal/Modal";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";

import "./TeacherResume.css";
import { connect } from "react-redux";
import {
  deleteQualification,
  deleteProfessionalDevelopment,
  deleteProfessionalExperience,
  deleteRefereeCheck,
  deleteNonTeachingExperience,
} from "../../redux/homePage/homePage.actions";
import useModal from "./useModal";
import moment from 'moment'
import {displayPoliceCheckWwCC} from "../Container/HomeContainer2";
import TeacherHours from "../../Components/CountDown/TeacherHours";
import { EcecDegree, teacherLevel } from "../../Helper";
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import EcecQualificationForm from "./EcecQualificationForm";
import ImportGoogleDriveFile  from "../../Components/GoogleDrive/ImportFile";
import EcecQualificationModal from "./EcecQualificationModal";
import { API } from "../../API";
import { notify } from "react-notify-toast";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';

const EcecResumeContent = (props) => {
  const { user, isViewAsTeacher } = props;
  const {
    deleteQualification,
    deleteProfessionalDevelopment,
    deleteProfessionalExperience,
    deleteRefereeCheck,
    deleteNonTeachingExperience,
  } = props;

  const { isShowing, toggle } = useModal();
  const [content, setContent] = useState();
  const [qTarget, setQTarget] = useState("");
  const [qType, setQType] = useState("");
  const [isPopup, togglePopup] = useState(false);
  const [isCreate, toggleCreate] = useState(true);
  const [qualificationID, setQualificationID] = useState("");
  const [formType, setFormType] = useState("");
  const [isDeleteQuaPopup, toggleDeleteQuaPopup] = useState(false);
  const [file, setFile] = useState(null)
  const [fileFromDrive, setFileFromDrive] = useState(null)
  const [isQualPopup, toggleQualPopup] = useState(false);
  const [isUploadDrive, setIsUploadDrive] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const [certificateFile, setCertificateFile] = useState(null)
  const [transcriptFile, setTranscriptFile] = useState(null)
  const [evidenceEnrolmentFile, setEvidenceEnrolmentFile] = useState(null)
  const [isEdit, setIsEdit] = useState(false)

  const quali_ref = React.createRef();
  const exp_ref = React.createRef();
  const referee_ref = React.createRef();

  const delete_confirm = () => {
    if (qType != null) {
      if (qType == 'qualification') {
        deleteQualification(qTarget._id)
      } else if (qType == 'prof_dev') {
        deleteProfessionalDevelopment(qTarget._id)
      } else if (qType == 'tech_exp') {
        deleteProfessionalExperience(qTarget._id)
      } else if (qType == 'other_pro_exp') {
        deleteNonTeachingExperience(qTarget._id)
      } else if (qType == 'pro_refree') {
        deleteRefereeCheck(qTarget._id)
      }
    }
    toggle()
  }

  const showAddReferee = (q) => {
    if (q) {
      setContent(q);
    } else {
      setContent("");
    }
    setFormType("referee");
    toggleCreate(true);
    togglePopup(true);
  };

  const showAddQualifications = () => {
    setContent("");
    setFormType("qualification");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(false)
  };

  const editAddQualifications = (q) => {
    setContent(q);
    setFormType("qualification");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(true)

  };
  const showAddPD = () => {
    setContent("");
    setFormType("PD");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(false)
  };

  const editAddPD = (q) => {
    setContent(q);
    setFormType("PD");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(true)
  };

  const showAddPE = () => {
    setContent("");
    setFormType("PE");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(false)
  };

  const editAddPE = (q) => {
    setContent(q);
    setFormType("PE");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(true)
  };

  const showAddNTE = () => {
    setContent("");
    setFormType("NTE");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(false)
  };

  const editAddNTE = (q) => {
    setContent(q);
    setFormType("NTE");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(true)
  };

  let newUser;
  if (isDeleteQuaPopup) {
    // ======= Update user  =======
    newUser = Object.assign({}, user);
    const arr = newUser.qualifications.filter((q) => q._id !== qualificationID);
    newUser.qualifications = arr;
  }

  const getTeacherBadge = () => {
    let badge = <></>
    const qualifications = user.qualifications
    if (qualifications?.length === 0) return badge

    qualifications.sort(sortByDegree)

    for (let i = 0; i < qualifications.length; i++) {
      const qualification = qualifications[i]

      // if user has only 1 qualification and the qualification is currently enrolled,
      // the badge will show by user's level that selected by admin
      const hasEnrolledDegree = (i === qualifications.length - 1 && qualification.graduation_date === "Present" && user.level)
      const degree = hasEnrolledDegree ? user.level : qualification.degree
      const bachelorDegree = hasEnrolledDegree ? teacherLevel.BACHELOR || teacherLevel.GRADUATE_DIPLOMA : EcecDegree.BACHELOR
      const certDegree = hasEnrolledDegree ? teacherLevel.CERT : EcecDegree.CERT

      if ((qualification.graduation_date !== "Present" && qualification.qualification_url) || hasEnrolledDegree) {
        if (degree === bachelorDegree) {
            badge = (
              <>
                <WorkspacePremiumIcon sx={{
                  width: "42px",
                  height: "42px",
                  color: "gray",
                  '@media (max-width: 480px)': {
                    width: "15px",
                    height: "15px",
                  }
                }}/>
                <p className="badge-name">Bachelor</p>
              </>
            )
            break
        } else if (degree === certDegree) {
          badge = (
            <>
              <img
                className="cert-badge"
                src={require("../../assets/img/cert.png")}
                alt="cert badge"
              />
              <p className="badge-name">Cert</p>
            </>
          )
          break
        } else {
          badge = (
            <>
              <img
                className="cert-badge"
                src={require("../../assets/img/dip.png")}
                alt="diploma badge"
              />
              <p className="badge-name">Dip</p>
            </>
          )
          break
        }
      }
    }

    return badge
  }

  const sortByDegree = (a, b) => {
    const order = {
      [EcecDegree.BACHELOR] : 1,
      [EcecDegree.DIPLOMA]: 2,
      [EcecDegree.CERT]: 3
    };

    return order[a.degree] - order[b.degree];
  };

  const handleChangeFileDrag = async (fileUpload, qualificationType) => {
    setFile(fileUpload)

    let qualificationContent = {}
    const formData = new FormData();
    formData.append("file", fileUpload);

    try {
      setIsLoading(true)
      if (fileUpload?.type === 'application/pdf') {
        const res = await API.readTextFromFileDragDrop(formData);
        const text = res.data?.data;
      
        if (text) {
          const response = await API.readQualificationContentFromText({ data: text });
          qualificationContent = response.data?.data;
        }
      }

      setContent({
        certificate_filename: fileUpload.name,
        institution_name: qualificationContent?.institute || '',
        // graduation_date: qualificationContent?.date
      });
      setFormType("qualification");
      toggleCreate(true);
      toggleQualPopup(true);
      setIsLoading(false)
    } catch (error) {
      setContent({
        certificate_filename: fileUpload.name,
      });
      setFormType("qualification");
      toggleCreate(true);
      toggleQualPopup(true);
      setIsLoading(false)
      console.log('Error:', error);
    }
  }

  const handleChangeFileDragDrop = async (fileUpload, fileType, qualificationType) => {
    switch (fileType) {
      case "certificate":
        setCertificateFile(fileUpload)

        let qualificationContent = {}
        const formData = new FormData();
        formData.append("file", fileUpload);

        try {
          setIsLoading(true)
          if (fileUpload?.type === 'application/pdf') {
            const res = await API.readTextFromFileDragDrop(formData);
            const text = res.data?.data;
          
            if (text) {
              const response = await API.readQualificationContentFromText({ data: text });
              qualificationContent = response.data?.data;
            }
          }

          setContent({
            ...content,
            certificate_filename: fileUpload.name,
            institution_name: qualificationContent?.institute || '',
            // graduation_date: qualificationContent?.date
          });
          setFormType("qualification");
          toggleCreate(true);
          setIsLoading(false)
        } catch (error) {
          setContent({
            ...content,
            certificate_filename: fileUpload.name,
          });
          setFormType("qualification");
          toggleCreate(true);
          setIsLoading(false)
          console.log('Error:', error);
        }
        break;
      case "transcript":
        setTranscriptFile(fileUpload)
        setContent({
          ...content,
          certificate_filename: fileUpload.name,
        });
        break;
      case "evidence-enrolment":
        setEvidenceEnrolmentFile(fileUpload)
        setContent({
          ...content,
          enrolment_filename: fileUpload.name,
        });
        break;
    }
  }

  const handleSelectFile = async (fileUpload, qualificationType) => {
    setFile(fileUpload?.fileId)
    let qualificationContent = {}

    try {
      setIsLoading(true)
      if (fileUpload?.mimeType === 'application/pdf') {
        const res = await API.readTextFromGoogleDriveFile(fileUpload);
        const text = res.data?.data;
      
        if (text) {
          const response = await API.readQualificationContentFromText({ data: text });
          qualificationContent = response.data?.data;
        }
      }

      setContent({
        certificate_filename: fileUpload.name,
        institution_name: qualificationContent?.institute || '',
        // graduation_date: qualificationContent?.date
      });

      setIsUploadDrive(true)
      setFileFromDrive(fileUpload)
      setFormType("qualification");
      toggleCreate(true);
      toggleQualPopup(true)
      setIsLoading(true)
    } catch (error) {
      setContent({
        certificate_filename: fileUpload.name,
      });

      setIsUploadDrive(true)
      setFileFromDrive(fileUpload)
      setFormType("qualification");
      toggleCreate(true);
      toggleQualPopup(true)
      setIsLoading(true)
      console.log('Error:', error);
    }
  }

  const resetAllFilesUpload = () => {
    setCertificateFile(null)
    setTranscriptFile(null)
    setEvidenceEnrolmentFile(null)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }

  useEffect(() => {
    var focus_ref = null
    switch (window.location.hash) {
      case "#updateQualification":
        focus_ref = quali_ref
        break;
      case "#updateExp":
        focus_ref = exp_ref
        break;
      case "#updateReferee":
        focus_ref = referee_ref
        break;
      default:
        break;
    }
    if (focus_ref) {
      console.log('scroll')
      focus_ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
    getTeacherBadge()
  }, [])

  return (
    <div className="teacher-profile-wrapper mt-3">
      {isPopup && (
        <EcecQualificationForm
          user={user}
          showPopup={togglePopup}
          isCreate={isCreate}
          qualificationID={qualificationID}
          formType={formType}
          content={content}
          toggleLoading={(status) => setIsLoading(status)}
          handleChangeFileDragDrop={handleChangeFileDragDrop}
          certificateFile={certificateFile}
          transcriptFile={transcriptFile}
          evidenceEnrolmentFile={evidenceEnrolmentFile}
          isEdit={isEdit}
          resetAllFilesUpload={resetAllFilesUpload}
        />
      )}
      {/* {isQualPopup && (
        <EcecQualificationModal
          user={user}
          showPopup={toggleQualPopup}
          isCreate={isCreate}
          qualificationID={qualificationID}
          formType={formType}
          content={content}
          file={file}
          resetFile={() => setFile(null)}
          isUploadDrive={isUploadDrive}
          fileFromDrive={fileFromDrive}
          stopLoading={stopLoading}
          toggleLoading={(status) => setIsLoading(status)}
        />
      )} */}
      <div className="container p-0">
        <div className="row">
          <div className="col-lg-6">
            <span ref={quali_ref}></span>
            {/*Qualifications Box */}
            <ProfileBox
              header="Qualifications"
              footer={
                isViewAsTeacher && (
                  <span onClick={showAddQualifications}>
                    <Icon
                      name="add"
                      circular
                      inverted
                      color="#3bb4d8"
                      className="qualification-container-update-icon"
                    >
                      {" "}
                    </Icon>
                    {"  "}Add New
                  </span>
                )
              }
            >
              <ul className="container p-0">
                {/* {
                  isViewAsTeacher && 
                    <ImportGoogleDriveFile
                      handleSelectFile={handleSelectFile}
                    />
                } */}

                {user.qualifications && user.qualifications.length > 0
                  ? user.qualifications
                  .sort((a, b) => {
                    let dateA, dateB;
                    dateA = a.graduation_date === "Present" ? moment() : moment(a.graduation_date, "MM/YYYY")
                    dateB = b.graduation_date === "Present" ? moment() : moment(b.graduation_date, "MM/YYYY")
                    return dateB.diff(dateA)
                  })
                  .map((q, index, array) => {
                    return (
                      <li key={q._id} className="row">
                        <div className="col-8">
                          <p className="mb-2 profile-qualification-title text-left">
                            {q?.status === "approved" ? <VerifiedUserOutlinedIcon sx={{color: 'green'}} /> : <VerifiedUserOutlinedIcon/>}
                            {q.degree} {q.award_name}
                          </p>
                          {q.major ?
                            <p className="mb-2 profile-qualification-title text-left">
                              ({q.major})
                            </p>
                            : ""}
                          <p className="mb-2 profile-qualification-place text-left">
                            {q.institution_name}{q.institution_city ? `, ${q.institution_city}` : ''}{q.institution_country ? `, ${q.institution_country}` : ''}
                          </p>

                          <p className="profile-qualification-place text-left">
                            <Icon
                              name="file text outline"
                              onClick={() => editAddQualifications(q)}
                              className="qualification-container-update-icon"
                            >
                              {" "}
                            </Icon>
                            {q.graduation_date === "Present" ? (
                              <Link
                                to={{
                                  pathname: `/NavigateToFileViewer?fileurl=${q.enrolment_url
                                    }`,
                                }}

                                target="_blank"
                                className="profile-qualification-place"
                              >
                                SOE
                              </Link>
                            ) : (
                              <>
                                {q.qualification_url ? (
                                  <Link
                                    to={{
                                      pathname: `/NavigateToFileViewer?fileurl=${q.qualification_url
                                        }`,
                                    }}
                                    target="_blank"
                                    className="profile-qualification-place"
                                  >
                                    Certificate
                                  </Link>
                                ) : (
                                  ""
                                )}
                                {q.qualification_url && q.transcript_url
                                  ? " | "
                                  : ""}
                                {q.transcript_url ? (
                                  <Link
                                    to={{
                                      pathname: `/NavigateToFileViewer?fileurl=${q.transcript_url
                                        }`,
                                    }}
                                    target="_blank"
                                    className="profile-qualification-place"
                                  >
                                    Transcript
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </p>
                        </div>

                        <div className="col-4">
                          <p className="mt-0 mb-0 profile-qualification-title text-right">
                            {q.graduation_date === "Present" ?
                              "Currently Enrolled"
                              :
                              moment(q.graduation_date, "MM/YYYY").format("MMM YYYY")
                            }
                          </p>
                          {isViewAsTeacher ? (
                            <p className="mb-0 profile-qualification-title text-right mt-2">
                              <Icon
                                name="pencil"
                                circular
                                inverted
                                color="#3bb4d8"
                                onClick={() => editAddQualifications(q)}
                                className="qualification-container-update-icon"
                              >
                                {" "}
                              </Icon>
                              <Icon
                                name="trash"
                                circular
                                inverted
                                color="grey"
                                onClick={() => {
                                  setQTarget(q)
                                  setQType('qualification')
                                  toggle(true)
                                }}
                                className="qualification-container-update-icon"
                              >
                                {" "}
                              </Icon>
                            </p>
                          ) : null}
                        </div>
                        {index !== array.length - 1 && (
                          <div className="col-12">
                            <hr className="qualification-line-1 my-3"></hr>
                          </div>
                        )}
                      </li>
                    );
                  })
                  : "No information available"
                }
              </ul>
            </ProfileBox>

            {/* professional development */}
            <ProfileBox
              header="Professional Development"
              footer={
                isViewAsTeacher && (
                  <span onClick={showAddPD}>
                    <Icon
                      name="add"
                      circular
                      inverted
                      color="#3bb4d8"
                      className="qualification-container-update-icon"
                    >
                      {" "}
                    </Icon>
                    {"  "}Add New
                  </span>
                )
              }
            >
              {user.professional_developments.length > 0
                ?
                <ul className="container p-0">
                  {user.professional_developments
                    .sort((a, b) => {
                      let dateA = a.end_date === "Present" ? moment() : moment(a.end_date, "MM/YYYY")
                      let dateB = b.end_date === "Present" ? moment() : moment(b.end_date, "MM/YYYY")
                      return dateB.diff(dateA)
                    })
                    .map((q, index, array) => {
                      return (
                        <li key={q._id} className="p-0">
                          <div className="row">
                            <div className="col-8">
                              <p className="mb-2 profile-qualification-title text-left">
                                {q.activity}
                              </p>
                              <p className="mb-2 profile-qualification-place text-left">
                                {q.focus_event}
                              </p>
                              <p className="profile-qualification-place text-left">
                                {q.location}{q.institution_city ? `, ${q.institution_city}` : ''}{q.institution_country ? `, ${q.institution_country}` : ''}
                              </p>
                            </div>

                            <div className="col-4">
                              <p className="mt-0 mb-0 profile-qualification-title text-right">
                                {q.end_date === "Present" ?
                                  "Currently Enrolled"
                                  :
                                  moment(q.end_date, "MM/YYYY").format("MMM YYYY")
                                }
                              </p>

                              {isViewAsTeacher ? (
                                <p className="mb-0 profile-qualification-title text-right mt-2">
                                  <Icon
                                    name="pencil"
                                    circular
                                    inverted
                                    color="#3bb4d8"
                                    onClick={() => editAddPD(q)}
                                    className="qualification-container-update-icon"
                                  >
                                    {" "}
                                  </Icon>
                                  <Icon
                                    name="trash"
                                    circular
                                    inverted
                                    color="grey"
                                    onClick={() => {
                                      setQTarget(q)
                                      setQType('prof_dev')
                                      toggle(true)
                                    }}
                                    className="qualification-container-update-icon"
                                  // id={q._id}
                                  >
                                    {" "}
                                  </Icon>
                                </p>
                              ) : null}
                            </div>
                            {index !== array.length - 1 && (
                              <div className="col-12">
                                <hr className="qualification-line-1 my-3"></hr>
                              </div>
                            )}
                          </div>
                        </li>
                      );
                    })
                  }
                </ul>
                : null}
            </ProfileBox>

            {/* Police, Children, First Aid & Qual. Checks */}
            <ProfileBox header='Police, Children, First Aid & Qual. Checks'>
              <div>{displayPoliceCheckWwCC}</div>
            </ProfileBox>
          </div>

          <div className="col-lg-6">
            <div className="experience">
              <TeacherHours user={user} />
              <div className="d-flex flex-column align-items-center">
                {getTeacherBadge()}
                {console.log(getTeacherBadge())}
                {/* {user.level === teacherLevel.CERT
                  ? <>
                      <img
                        className="cert-badge"
                        src={require("../../assets/img/cert.png")}
                        alt="cert badge"
                      />
                      <p className="badge-name">Cert</p>
                    </>
                  : (
                    user.level === teacherLevel.DIPLOMA
                      ? <>
                        <img
                          className="cert-badge"
                          src={require("../../assets/img/dip.png")}
                          alt="diploma badge"
                        />
                        <p className="badge-name">Dip</p>
                        </>
                      : <>
                          <WorkspacePremiumIcon sx={{
                            width: "42px",
                            height: "42px",
                            color: "gray",
                            '@media (max-width: 480px)': {
                              width: "15px",
                              height: "15px",
                            }
                          }}/>
                          <p className="badge-name">Bachelor</p>
                        </>
                    )
                } */}
              </div>
            </div>
            <div>
              {/*  ChildCare Experience*/}
              <span ref={exp_ref}></span>
              <ProfileBox
                header="ChildCare Experience"
                footer={
                  isViewAsTeacher && (
                    <span onClick={showAddPE}>
                      <Icon
                        name="add"
                        circular
                        inverted
                        color="#3bb4d8"
                        className="qualification-container-update-icon"
                      >
                        {" "}
                      </Icon>
                      {"  "}Add New
                    </span>
                  )
                }
              >
                {user.professional_experience.length > 0
                  ?
                  <ul className="container p-0">
                    {user.professional_experience
                      .sort((a, b) => {
                        let dateA, dateB;
                        if (a.end_date === b.end_date) {
                          dateA = moment(a.start_date, "MM/YYYY");
                          dateB = moment(b.start_date, "MM/YYYY");
                        }
                        else {
                          dateA = a.end_date === "Present" ? moment() : moment(a.end_date, "MM/YYYY")
                          dateB = b.end_date === "Present" ? moment() : moment(b.end_date, "MM/YYYY")
                        }
                        return dateB.diff(dateA)
                      })
                      .map((q, index, array) => {
                        return (
                          <li key={q._id} className="p-0">
                            <div className="row">
                              <div className="col-8">
                                {/* <p className="mt-0 mb-0 profile-qualification-title text-left">{q.graduation_date}</p> */}
                                <p className="mt-0 mb-2 profile-qualification-title text-left">
                                  {q.organisation}
                                </p>
                                <p className="mt-0 mb-2 profile-qualification-place text-left">
                                  {q.institution_city ? `${q.institution_city}` : ''}{q.institution_country ? `, ${q.institution_country}` : ''}
                                </p>
                                <p className="profile-qualification-place text-left">
                                  {q.course_class_delivered.length > 0
                                    ? q.course_class_delivered
                                      .map((item) => item.value)
                                      .join(" | ")
                                    : q.course_class_delivered}
                                </p>
                                {q.qualification_url ? (
                                  q.qualification_status ? (
                                    <p className="mt-2 profile-qualification-place text-left">
                                      <i className="mdi mdi-checkbox-marked-circle float-righte green"></i>
                                      Verified
                                    </p>
                                  ) : (
                                    <p className="mt-2 profile-qualification-place text-left red">
                                      Awaiting Verification
                                    </p>
                                  )
                                ) : null}
                                {
                                  q?._id === "dc1837d9-d5d8-40b7-b8e5-e931a90065e5" && (
                                    <div className="profile-qualification-place text-left">
                                      English for Academic Purposes (16 week
                                      program): EAP course for EFL teacher
                                      candidates in the first year of their program.
                                      Course focus: academic writing & writing skill
                                      development, such as mastering paragraph
                                      writing through a process-oriented approach.
                                      Students learned to create diverse paragraph
                                      types and effectively connect them in cohesive
                                      essays.
                                    </div>
                                  )
                                }
                                {
                                  q?._id === "c7a1e94e-2d2e-4c80-9aeb-57f691c4b7c7" && (
                                    <div className="profile-qualification-place text-left">
                                      Deliver two-year HSP course to Year 11 & 12 students on various genres of writing including poetry, prose and essay writing.
                                    </div>
                                  )
                                }
                                {
                                  q?._id === "424fb6b0-e715-4dbc-bf03-abbc51497caf" && (
                                    <div className="profile-qualification-place text-left">
                                      Deliver a 10-week course aimed at development of test taking strategies and improve TOEFL test score to enable learners to apply for postgraduate scholarships
                                    </div>
                                  )
                                }
                                {
                                  q?._id === "4a3d6956-4219-435c-9e42-af50f9cbb91c" && (
                                    <div className="profile-qualification-place text-left">
                                      12-week course aimed at TOEFL test score improvement to enable learners to apply for postgraduate scholarships. Included Paragraph Writing, Essay Writing, Referencing, Paraphrasing skill.
                                    </div>
                                  )
                                }
                                {
                                  q?._id === "20291402-64ff-4b35-83c9-1c1fe35ad0e7" && (
                                    <div className="profile-qualification-place text-left">
                                      Various EAP courses exploring dimensions of Qualitative Research including reflective studies, classroom oriented research, case studies, narrative inquiries, diary studies, etc.; collecting, compiling, and analysing diverse types of research data; various academic texts such as book review article, classroom idea article, original research article, position article, practice based article and reflection based article; reading strategies to comprehend academic texts reading; analyse academic writing in terms of grammar, content, genre, pattern of development, and stylistic features;  experience delivering ceremonial, informative, and persuasive speeches; develop analytical and critical listening skills.
                                    </div>
                                  )
                                }
                                {
                                  q?._id === "a074ba24-3a15-4b6c-95a4-37c9f74efa49" && (
                                    <div className="profile-qualification-place text-left">
                                      Research skills, plagiarism, reference writing and citation, working on academic vocabulary and grammar (structures), how to prepare presentations and public speaking skills. Paraphrasing and summarising academic texts, and familiarising students with marking procedures. Academic discussions, how to write assignments and essays for academic purposes, even how to ask questions in academic contexts.
                                    </div>
                                  )
                                }
                                {
                                  q?._id === "06ee2ced-68b0-4d3c-8c90-6970e616ceca" && (
                                    <div className="profile-qualification-place text-left">
                                      EAP Bridging courses including content-based instruction from degree subjects. Course length varied from 5 to 40 weeks. Advanced EAP, effective communication, ethical attitude, academic enquiry and analysis engagement, building debating skills, understanding literary texts of different genres and periods, acquiring critical approach and study skills, developing note-taking and referencing skills.
                                    </div>
                                  )
                                }
                              </div>
                              <div className="col-4">
                                <p className="mt-0 mb-0 profile-qualification-title text-right">
                                  {q?._id === "dc1837d9-d5d8-40b7-b8e5-e931a90065e5" ? "Jan 2009 - Dec 2011" : 
                                  moment(q.start_date, "MM/YYYY").format("MMM YYYY")
                                    + " - " +
                                    (q.end_date === "Present" ? q.end_date : moment(q.end_date, "MM/YYYY").format("MMM YYYY"))
                                  }
                                </p>
                                {isViewAsTeacher ? (
                                  <p className="mb-0 profile-qualification-title text-right mt-2">
                                    <Icon
                                      name="pencil"
                                      circular
                                      inverted
                                      color="#3bb4d8"
                                      onClick={() => editAddPE(q)}
                                      className="qualification-container-update-icon"
                                    >
                                      {" "}
                                    </Icon>
                                    <Icon
                                      name="trash"
                                      circular
                                      inverted
                                      color="grey"
                                      onClick={() => {
                                        setQTarget(q)
                                        setQType('tech_exp')
                                        toggle(true)
                                      }}
                                      className="qualification-container-update-icon"
                                    >
                                      {" "}
                                    </Icon>
                                  </p>
                                ) : null}
                              </div>
                              {index !== array.length - 1 && (
                                <div className="col-12">
                                  <hr className="qualification-line-1 my-3"></hr>
                                </div>
                              )}
                            </div>
                          </li>
                        );
                      })
                    }
                  </ul>
                  : null}
              </ProfileBox>
            </div>

            <div>
              {/*  PROFESSIONAL REFEREE*/}
              {props.isViewAsTeacher && (
                <>
                  <span ref={referee_ref}></span>
                  <ProfileBox
                    header="Professional Referee"
                    footer={
                      isViewAsTeacher && (!user.referees || user.referees.length < 2) && (
                        <span onClick={() => showAddReferee()}>
                          <Icon
                            name="add"
                            circular
                            inverted
                            color="#3bb4d8"
                            className="qualification-container-update-icon"
                          >
                            {" "}
                          </Icon>
                          {"  "}Add New
                        </span>
                      )
                    }
                  >
                    {user.referees.length > 0
                      ?
                      <ul className="container p-0">
                        {user.referees.map((q, index, array) => {
                          return (
                            <li key={q._id} className="p-0">
                              <div className="row">
                                <div className="col-8">
                                  <p className="mt-0 mb-2 profile-qualification-title text-left">
                                    {q.organisation}
                                  </p>
                                  <p className="mt-0 mb-2 profile-qualification-place text-left">
                                    {q.referee_first_name +
                                      " " +
                                      q.referee_last_name +
                                      "  (" +
                                      q.referee_position_title +
                                      ")"}
                                  </p>
                                  <p className="profile-qualification-place text-left">
                                    {q.referee_email}
                                  </p>
                                </div>

                                {isViewAsTeacher ? (
                                  <div className="col-4">
                                    <p className="mb-0 profile-qualification-title text-right mt-2">
                                      <Icon
                                        name="pencil"
                                        circular
                                        inverted
                                        color="#3bb4d8"
                                        onClick={() => showAddReferee(q)}
                                        className="qualification-container-update-icon"
                                      >
                                        {" "}
                                      </Icon>
                                      <Icon
                                        name="trash"
                                        circular
                                        inverted
                                        color="grey"
                                        onClick={() => {
                                          setQTarget(q)
                                          setQType('pro_refree')
                                          toggle(true)
                                        }}
                                        className="qualification-container-update-icon"
                                      >
                                        {" "}
                                      </Icon>
                                    </p>
                                  </div>
                                ) : null}
                                <hr className="qualification-line-1"></hr>
                              </div>
                            </li>
                          );
                        })
                        }
                      </ul>
                      : null}
                  </ProfileBox>
                </>
              )}
            </div>

            <div>
              {/*  OTHER PROFESSIONAL EXPERIENCE*/}
              <ProfileBox
                header="Other Experience"
                footer={
                  isViewAsTeacher && (
                    <span onClick={showAddNTE}>
                      <Icon
                        name="add"
                        circular
                        inverted
                        color="#3bb4d8"
                        className="qualification-container-update-icon"
                      >
                        {" "}
                      </Icon>
                      {"  "}Add New
                    </span>
                  )
                }
              >
                {user.non_teaching_experience.length > 0
                  ?
                  <ul className="container p-0">
                    {user.non_teaching_experience
                      .sort((a, b) => {
                        let dateA, dateB;
                        if (a.end_date === b.end_date) {
                          dateA = moment(a.start_date, "MM/YYYY");
                          dateB = moment(b.start_date, "MM/YYYY");
                        }
                        else {
                          dateA = a.end_date === "Present" ? moment() : moment(a.end_date, "MM/YYYY")
                          dateB = b.end_date === "Present" ? moment() : moment(b.end_date, "MM/YYYY")
                        }
                        return dateB.diff(dateA)
                      })
                      .map((q, index, array) => {
                        let main_duties = q.main_duties.split(" ");
                        if (main_duties.length > 75) {
                          main_duties = main_duties.slice(0, 75).join(" ") + " ..."
                        }
                        else {
                          main_duties = q.main_duties;
                        }
                        return (
                          <li key={q._id} className="p-0">
                            <div className="row">
                              <div className="col-8">
                                <p className="mt-0 mb-2 profile-qualification-title text-left">
                                  {q.role_held}
                                </p>
                                <p className="mt-0 mb-2 profile-qualification-place text-left">
                                  {main_duties}
                                </p>
                                <p className="profile-qualification-place text-left">
                                  {q.organisation + ", "}
                                  {q.institution_city ? `${q.institution_city}` : ''}{q.institution_country ? `, ${q.institution_country}` : ''}
                                </p>
                              </div>

                              <div className="col-4">
                                <p className="mt-0 mb-0 profile-qualification-title text-right">
                                  {moment(q.start_date, "MM/YYYY").format("MMM YYYY")
                                    + " - " +
                                    (q.end_date === "Present" ? q.end_date : moment(q.end_date, "MM/YYYY").format("MMM YYYY"))
                                  }
                                </p>
                                {isViewAsTeacher ? (
                                  <p className="mb-0 profile-qualification-title text-right mt-2">
                                    <Icon
                                      name="pencil"
                                      circular
                                      inverted
                                      color="#3bb4d8"
                                      onClick={() => editAddNTE(q)}
                                      className="qualification-container-update-icon"
                                    >
                                      {" "}
                                    </Icon>
                                    <Icon
                                      name="trash"
                                      circular
                                      inverted
                                      color="grey"
                                      onClick={() => {
                                        setQTarget(q)
                                        setQType('other_pro_exp')
                                        toggle(true)
                                      }}
                                      className="qualification-container-update-icon"
                                    >
                                      {" "}
                                    </Icon>
                                  </p>
                                ) : null}
                              </div>
                              {index !== array.length - 1 && (
                                <div className="col-12">
                                  <hr className="qualification-line-1 my-3"></hr>
                                </div>
                              )}
                            </div>
                          </li>
                        );
                      })
                    }
                  </ul>
                  : null}
              </ProfileBox>
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="confirm-delete"
        header="Do you wish to delete?"
        show={isShowing}
        onClose={toggle}
      >
        <div className="row m-0">
          <div className="col-md-6">
            <CancelButton
              type="button"
              onClick={toggle}
            >
              Cancel
            </CancelButton>
          </div>
          <div className="col-md-6 padding-for-mobile">
            <ConfirmButton
              type="button"
              onClick={delete_confirm}
              id={'q._id'}
            >
              Yes and Proceed
            </ConfirmButton>
          </div>
        </div>
      </Modal>

      <Backdrop
        sx={{ color: '#fff', zIndex: 1200 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  deleteQualification: (user) => dispatch(deleteQualification(user)),
  deleteProfessionalDevelopment: (user) =>
    dispatch(deleteProfessionalDevelopment(user)),
  deleteProfessionalExperience: (user) =>
    dispatch(deleteProfessionalExperience(user)),
  deleteRefereeCheck: (user) => dispatch(deleteRefereeCheck(user)),
  deleteNonTeachingExperience: (user) =>
    dispatch(deleteNonTeachingExperience(user)),
});

export default connect(null, mapDispatchToProps)(EcecResumeContent);
